import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NovoChamadoFormProvider } from 'src/app/providers';
import {
  ICardComponentData,
  ICidade,
  IEstado,
  IPostOSBody,
  ISite
} from 'src/app/interfaces';
import {
  OSService,
  IBGEService,
  AuthenticationService
} from 'src/app/services';
import { CepService } from 'src/app/services/cep/cep.service';

@Component({
  selector: 'app-abrir-chamado-c',
  templateUrl: './abrir-chamado-c.component.html',
  styleUrls: ['./abrir-chamado-c.component.scss']
})
export class AbrirChamadoCComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  cardData: ICardComponentData[] = [];
  form: FormGroup;
  formPrimeiroPasso: FormGroup;
  formSegundoPasso: FormGroup;
  states: IEstado[] = [];
  cities: ICidade[] = [];
  token = this.authenticationService.obterToken();

  constructor(
    private novoChamadoFormProvider: NovoChamadoFormProvider,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private IBGEService: IBGEService,
    private OSService: OSService,
    private authenticationService: AuthenticationService,
    private cepService: CepService
  ) {}

  get f(): any {
    return this.form.controls;
  }

  getAddressByCep(valor) {
    this.cepService
      .getAddresByCep(valor)
      .subscribe((dados) => this.populaForm(dados));
  }
  onCepKeyUp(cep: string) {
    if (cep.length === 8) {
      this.getAddressByCep(cep);
    }
  }

  populaForm(dados) {
    this.getCities(dados.uf);
    this.form.patchValue({
      cep: dados.cep.replace('-', ''),
      logradouro: dados.logradouro,
      cidade: dados.localidade.toUpperCase(),
      estado: dados.uf,
      bairro: dados.bairro
    });
  }

  handleAddress(checked: boolean) {
    const siteSelecionado: ISite = this.formPrimeiroPasso.get('site')?.value;
    if (checked) {
      this.getCities(siteSelecionado.estado);
      this.form.setValue({
        cep: siteSelecionado.cep,
        logradouro: siteSelecionado.logradouro,
        num: siteSelecionado.numero,
        cidade: siteSelecionado.cidade!.toUpperCase(),
        estado: siteSelecionado.estado,
        bairro: siteSelecionado.bairro,
        comp: siteSelecionado.complemento
          ? siteSelecionado.complemento.substring(0, 20)
          : ''
      });
      this.form.disable();
      return;
    }
    this.form.enable();
  }

  limparEndereco(checked: boolean) {
    if (checked) {
      return;
    }
    this.form.reset();
  }

  getState() {
    this.subscriptions$.add(
      this.IBGEService.getEstados().subscribe({
        next: (response) => {
          this.states = response;
        }
      })
    );
  }

  getCities(state: string | null | undefined) {
    this.subscriptions$.add(
      this.IBGEService.getCidadesPorEstado(state!).subscribe({
        next: (response) => {
          this.cities = response;
        }
      })
    );
  }

  submitForm() {
    const body: IPostOSBody = {
      codContrato: this.formPrimeiroPasso.get('contrato')?.value.codContrato,
      codDefeito: this.formPrimeiroPasso.get('codDefeito')?.value,
      obsDefeito: this.formPrimeiroPasso.get('obsDefeito')?.value,
      numpat: this.formPrimeiroPasso.get('numpat')?.value,
      numserie: this.formPrimeiroPasso.get('numserie')?.value,
      solicitante:
        this.formSegundoPasso.get('contato')?.value || this.token.nome,
      cep: this.form.get('cep')?.value,
      logradouro: this.form.get('logradouro')?.value,
      num: this.form.get('num')?.value,
      comp: this.form.get('comp')?.value,
      bairro: this.form.get('bairro')?.value,
      cidade: this.form.get('cidade')?.value,
      estado: this.form.get('estado')?.value,
      fone: this.formSegundoPasso.get('fone')?.value,
      foneaux: this.formSegundoPasso.get('foneaux')?.value,
      contato: this.formSegundoPasso.get('contato')?.value,
      email: this.token.email,
      celular: this.formSegundoPasso.get('celular')?.value,
      motivo: this.formPrimeiroPasso.get('motivo')?.value
    };

    this.subscriptions$.add(
      this.OSService.postOS(body).subscribe({
        next: ({ data }) => {
          const queryParams = {
            codigoOs: data,
            codContrato:
              this.formPrimeiroPasso.get('contrato')?.value.codContrato,
            numSerie: this.formPrimeiroPasso.get('numserie')?.value
          };
          this.novoChamadoFormProvider.limparForm();
          this.router.navigate(['/equipamento/abrir-chamado/4'], {
            queryParams
          });
        }
      })
    );
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const cardDataString = params['cardData'];
      if (cardDataString) {
        this.cardData = JSON.parse(cardDataString);
      }
    });
    const segundoPassoInvalido = this.novoChamadoFormProvider
      .getForm()
      .get('segundoPasso')?.valid;
    if (!segundoPassoInvalido) {
      this.location.back();
      return;
    }

    this.formPrimeiroPasso = this.novoChamadoFormProvider
      .getForm()
      .get('primeiroPasso') as FormGroup;

    this.formSegundoPasso = this.novoChamadoFormProvider
      .getForm()
      .get('segundoPasso') as FormGroup;

    this.form = this.novoChamadoFormProvider
      .getForm()
      .get('terceiroPasso') as FormGroup;
    this.form.reset();
    this.form.enable();

    this.getState();
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
